import axios from "axios";
import config from "../config/config";

export const login = async (email, password, callback) => {
  try {
    let response = await axios({
      method: "POST",
      url: `${config.server.url}/auth/signInAdmin`,
      data: {
        email,
        password,
      },
    });
    if (response.status === 200) {
      callback(null, response.data);
    }
  } catch (error) {
    if (
      error.response.status === 400 ||
      error.response.status === 404 ||
      error.response.status === 500
    ) {
      if (error.response.data) {
        callback(error.response.data, null);
      }
    }
  }
};

export const resetPassword = async (email, callback) => {
  try {
    let response = await axios({
      method: "POST",
      url: `${config.server.url}/auth/resetPassword`,
      data: {
        email,
      },
    });

    if (response.status === 200) {
      callback(null, response.data);
    }
  } catch (error) {
    if (error.response.status === 404 || error.response.status === 500) {
      if (error.response.data) {
        callback(error.response.data, null);
      }
    }
  }
};

export const createPassword = async (email, newPassword, user_id, callback) => {
  try {
    let response = await axios({
      method: "POST",
      url: `${config.server.url}/auth/createPassword`,
      data: {
        email,
        password: newPassword,
        user_id,
      },
    });

    if (response.status === 200) {
      callback(null, response.data);
    }
  } catch (error) {
    if (error.response.status === 404 || error.response.status === 500) {
      if (error.response.data) {
        callback(error.response.data, null);
      }
    }
  }
};
